import React from 'react';
import {connect} from 'react-redux';
import {Dimmer, Loader} from 'semantic-ui-react';
import {Redirect} from 'react-router-dom';
import _ from 'lodash';

import REST from 'go/requests/rest';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {ContentDispatch} from 'framework';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import PanelReviewTopNav from 'go/components/panelReview2/PanelReviewTopNav';
import NetworkErrorModal from 'go/components/dynamic/common/modals/NetworkErrorModal';
import {compileContent, isFemaUser, countDependenciesToLoad} from 'common/utils';
import {API_TASK_COMPLETE_SUCCESS} from 'common/types';
import {Contexts} from 'componentLibrary';
import {ADD_MSG} from 'common/types';
import {API_CONTEXT_GET_SUCCESS} from 'common/types';
import ApiActions from 'go/actions/api';
import {PANEL_APPLICANT_OVERVIEW} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

const {SubmitContext} = Contexts;

const SAVE_SCORES_NETWORK_ERROR_MSG =
  'You have encountered an unexpected error. Please refresh your browser and try again. If you continue to receive this message, please contact the help desk at <a href="mailto:femago@fema.dhs.gov">femago@fema.dhs.gov</a> or 1-877-611-4700.';
const SAVE_SCORES_NETWORK_ERROR_TITLE = 'Unexpected error';

export class PanelReviewContainer extends React.Component {
  state = {
    activeSection: 'Applicant Overview',
    loading: true,
    submitting: false,
    error: false,
    redirect: false,
  };

  componentDidMount() {
    document.title = PANEL_APPLICANT_OVERVIEW;
    let {token, match, getContext, configType} = this.props;

    let taskId = _.get(match, 'params.taskId');
    if (taskId) {
      return getContext(token, taskId)
        .then((res) => {
          if (res && res.type === API_CONTEXT_GET_SUCCESS) {
            const sessionData = _.get(res, 'payload.processVariables');
            const {
              sessionId,
              grantId,
              entityId,
              entityType,
              entityDisplay,
              organizationName,
            } = sessionData;
            const taskDefKey =
              configType && configType === 'entityView'
                ? 'entityView'
                : _.get(res, 'payload.task.taskDefinitionKey');
            this.setState({
              sessionId,
              grantId,
              entityId,
              entityType,
              entityDisplay,
              organizationName,
            });
            this.fetchSessionConfig(sessionId, taskDefKey).then((config) => {
              this.initializeReduxState(config, res.payload);
            });
            this.fetchSessionConfig(sessionId, 'aliases').then((config) => {
              this.setState({
                aliases: config.aliases,
              });
            });
          }
        })
        .catch((err) => {
          console.error('error');
          this.setState({
            error: true,
          });
        });
    } else {
      this.setState({
        error: true,
      });
    }
  }

  static getDerivedStateFromProps(props, state) {
    const dependencies = _.get(props, 'config.payload.dependencies');
    const toggles = _.get(props, 'toggles.toggles');
    const dependenciesToLoad = countDependenciesToLoad(
      dependencies,
      isFemaUser(_.get(state, 'auth.permissions')),
      toggles
    );
    if (
      state.initialized &&
      state.loading &&
      props.numLoadedSuccessfully === dependenciesToLoad
    ) {
      return {
        ...state,
        loading: false,
      };
    }
    return null;
  }

  fetchSessionConfig = (panelSessionId, taskDefKey) => {
    const {token} = this.props;
    return REST.panelReviewV2
      .getPanelSessionConfiguration(token, panelSessionId, taskDefKey)
      .then(REST.handler.handleResponse);
  };

  initializeReduxState = (config, workflowTask) => {
    const {init, auth, toggles, profile} = this.props;
    init({
      config,
      context: {
        auth,
        toggles,
        profile,
        workflowTask,
      },
      validations: {},
    });
    this.setState({initialized: true});
  };

  handleSubmit = async (taskPayload, password) => {
    let {token, match} = this.props;
    let taskId = _.get(match, 'params.taskId');
    let entityId = this.state.entityId;
    this.setState({submitting: true});
    const panelSessionId = this.props.match.params.sessionId;
    if (taskPayload.hasConflict) {
      return await REST.panelReviewV2
        .conflictOfInterest(this.props.token, panelSessionId, entityId)
        .then(REST.handler.handleResponse)
        .then((response) => {
          if (response) {
            this.setState({redirect: true});
          }
        })
        .catch((error) => {
          this.setState({
            error: true,
          });
          console.error('error');
        });
    }
    //before setting as complete we need to save the score and confirm the score is saved before completing task
    //check status to see if its in panelreview
    //go onto completing task
    return await this.completeTaskCall(taskId, taskPayload, token, password);
  };

  completeTaskCall = (taskId, taskPayload, token, password) => {
    let {completeTask} = this.props;
    taskPayload.grantId = this.props.grantId;
    taskPayload.organizationId = this.props.organizationId;
    taskPayload.programId = this.props.programId;
    taskPayload.userId = this.props.userId;
    taskPayload.author = this.props.userId;
    taskPayload.process = this.props.processWF;
    taskPayload.task = this.props.taskWF;
    return completeTask(taskId, taskPayload, token, password).then((res) => {
      if (res && res.type === API_TASK_COMPLETE_SUCCESS) {
        this.setState({redirect: true});
        return res;
      } else {
        if (_.get(res, 'meta.status') === 403) {
          this.setState({submitting: false});
          res.status = res.meta.status;
          return res;
        } else {
          this.setState({submitting: false, error: true});
          return res;
        }
      }
    });
  };

  handlePostSubmit = () => {
    const {config} = this.props;
    this.props.addMessage(_.get(config, 'rerouteMessage'));
  };

  handleErrorConfirmation = () => {
    this.props.history.push('/redirecting_page');
    this.props
      .clear()
      .then(() => {
        this.props.history.replace(this.props.routerLocation);
      })
      .catch((error) => {
        this.setState({
          error: true,
        });
      });
  };

  render() {
    let {config, location, data, match, applicationData} = this.props;
    const {sessionId, entityDisplay, organizationName, aliases} = this.state;
    let {error, redirect, loading, submitting, activeSection} = this.state;
    const rerouteOnSubmit = _.get(config, 'rerouteOnSubmit');

    const submitContext = {
      handleSubmit: this.handleSubmit,
      handlePostSubmit: this.handlePostSubmit,
    };

    const listeners = _.get(config, 'payload.listeners', []);
    const contents = _.get(config, 'payload.contents', []);
    return (
      <React.Fragment>
        <PanelReviewTopNav
          entityAlias={_.get(_.find(aliases, {value: 'id'}), 'label', 'Application ID')}
          entityDisplay={entityDisplay}
          organizationName={organizationName}
          section={_.get(
            _.find(aliases, {value: 'section'}),
            'label',
            'Applicant Overview '
          )}
          sessionId={sessionId}
        />
        <div className="sr-only">
          Information is automatically saved as fields are modified and focus is changed.
          You do not need to manually save data in FEMA GO.
        </div>
        {error && <Error />}
        {redirect && (
          <Redirect
            push
            to={
              rerouteOnSubmit
                ? compileContent(rerouteOnSubmit, this.props)
                : `/panelReview/sessions/${sessionId}/tasks`
            }
          />
        )}
        {loading && <Loader active>Loading...</Loader>}
        <NetworkErrorModal
          networkErrorPath="saveEntitySaga"
          errorTitle={SAVE_SCORES_NETWORK_ERROR_TITLE}
          errorMessage={SAVE_SCORES_NETWORK_ERROR_MSG}
          handleErrorConfirmation={this.handleErrorConfirmation}
        />
        {!loading && !error && !redirect && (
          <React.Fragment>
            {submitting && (
              <Dimmer active>
                <Loader />
              </Dimmer>
            )}
            {_.map(listeners, (listenerConfig, index) => (
              <ContentDispatch config={listenerConfig} key={index} />
            ))}
            <SubmitContext.Provider value={submitContext}>
              {_.map(contents, (itemConfig, index) => (
                <ContentDispatch
                  key={itemConfig.type + index}
                  config={itemConfig}
                  currentLocation={location}
                />
              ))}
            </SubmitContext.Provider>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const addMessage = (dispatch) => {
  return (msg) =>
    dispatch({
      type: ADD_MSG,
      msg: msg,
    });
};

export const mapDispatchToProps = (dispatch) => ({
  init: (initState) => dispatch(DynamicComponentActions.initWithState(initState)),
  clear: () => {
    return new Promise((resolve, reject) => {
      dispatch(DynamicComponentActions.clearDynamicComponent({}));
      resolve();
    });
  },
  addMessage: addMessage(dispatch),
  getContext: (token, id) => {
    let action = ApiActions.tasks.getContext(token, id);
    const res = dispatch(action);
    return res;
  },
  completeTask: (id, payload, token, password) => {
    const action = ApiActions.tasks.completeTask(
      id,
      JSON.stringify(payload),
      token,
      password
    );
    const res = dispatch(action);
    return res;
  },
});

export const mapStateToProps = (state) => {
  const currentLocation = _.get(state, 'dynamicComponent.currentLocation');
  const author = state.profile.firstName + ' ' + state.profile.lastName;
  return {
    auth: state.auth,
    profile: state.profile,
    toggles: state.toggles,
    token: state.auth.token,
    location: currentLocation === '' ? 'contents[0]' : currentLocation,
    applicationData: _.get(state, 'dynamicComponent.context.applicationDynamicData'),
    routerLocation: _.get(state, 'router.location.pathname'),
    config: _.get(state, 'dynamicComponent.config'),
    data: _.get(state, 'dynamicComponent.data'),
    userId: state.auth.userId,
    numLoadedSuccessfully: _.get(state, 'dynamicComponent.context.numLoadedSuccessfully'),
    organizationName: _.get(state, 'dynamicComponent.context.organization.displayName'),
    organizationState: _.get(
      state,
      'dynamicComponent.context.organization.physicalAddress.stateOrProvince'
    ),
    region: _.get(state, 'dynamicComponent.context.organization.region'),
    fundingOpportunityNumber: _.get(
      state,
      'dynamicComponent.context.fundingOpportunityData.fundingOpportunityNr'
    ),
    fundingOpportunityName: _.get(
      state,
      'dynamicComponent.context.fundingOpportunityData.fundingOpportunityName'
    ),
    grantId: _.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.grantId'
    ),
    organizationId: _.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.organizationId'
    ),
    programId: _.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.programId'
    ),
    author: author,
    taskWF: _.get(state, 'dynamicComponent.context.workflowTask.task.taskDefinitionKey'),
    processWF: _.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.processKey'
    ),
    panelReviewUserScoresV2: _.get(
      state,
      'dynamicComponent.context.panelReviewUserScoresV2'
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelReviewContainer);
